import { useState, useEffect, useRef } from 'react';
import { CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { logoutUser, nextHomeSignInAndLoad } from 'app/store/authSlice';
import { resetUserState } from 'app/store/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryParams } from '@/app/hooks/useQueryParams';
import { apiSlice } from '@/app/api/apiSlice';

function NextHomeSignInPage() {
  const [message, setMessage] = useState('');
  const queryParams = useQueryParams();
  const authState = useSelector(state => state.auth);
  const isInProgress = authState.nextHomeStatus === 'in progress';
  const timeout = useRef();

  const dispatch = useDispatch();

  const performSignIn = () => {
    timeout.current = null;
    if (isInProgress || authState.success) return;
    const params = {
      source: queryParams.get('source'),
      user: queryParams.get('user'),
      time: queryParams.get('time'),
      hash: queryParams.get('hash'),
    };
    if (!(params.source && params.user && params.time && params.hash)) {
      setMessage('Invalid URL parameters');
      return;
    }
    dispatch(nextHomeSignInAndLoad(params));
    setMessage('');
  };

  const signOutAndScheduleSignIn = async () => {
    if (authState.userToken && !isInProgress)
    {
      dispatch(resetUserState());
      dispatch(apiSlice.util.resetApiState());
      await dispatch(logoutUser()).unwrap();
    }
    // for some reason the component is mounted twice
    // this is a workaround preventing sending the request twice
    timeout.current = setTimeout(performSignIn, 500);

  }

  useEffect(() => {
    signOutAndScheduleSignIn();
    return () => {
      if (timeout.current) clearTimeout(timeout.current);
    }
  }, []);

  useEffect(() => {
    if (authState.error !== true) setMessage(authState.error);
  }, [authState.error]);

  return (
    <Paper className='flex flex-col items-center gap-16 h-full w-full py-8 px-16'>
      <Typography className='mt-28 text-4xl font-extrabold tracking-tight leading-tight'>
        Automatic Sign-in
      </Typography>
      {isInProgress && <CircularProgress />}
      {message && <Typography className='text-lg'>{message}</Typography>}
    </Paper>
  );
}

export default NextHomeSignInPage;
